import { Controller } from 'stimulus';
import { formatCurrency } from '@/js/shared/billables/currency';

export default class extends Controller {
  static targets = [
    'calculatedAmount',
    'methodSelect',
    'amountField',
    'amountInput',
    'percentageField',
    'percentageInput',
    'perItemToggle',
  ];

  get calculationInput() {
    if (!this.hasMethodSelectTarget) {
      return { method: 'per_line' };
    }

    return {
      method: this.methodSelectTarget.value,
      amount: this.amountInputTarget.value || '0',
      percentage: this.percentageInputTarget.value || '0',
    };
  }

  connect() {
    this.#syncInputState();
  }

  changeMethod() {
    this.#syncInputState();
    this.dispatch('method-changed', { detail: { method: this.methodSelectTarget.value } });
    this.dispatch('changed');
  }

  update() {
    this.dispatch('changed');
  }

  renderCalculatedAmount({ shipping, currency }) {
    this.calculatedAmountTarget.textContent = formatCurrency(shipping, currency, {
      useGrouping: false,
    });
  }

  #syncInputState() {
    if (!this.hasMethodSelectTarget) {
      return;
    }

    const method = this.methodSelectTarget.value;
    this.amountFieldTarget.classList.toggle('hide', method !== 'flat');
    this.percentageFieldTarget.classList.toggle('hide', method !== 'percentage');
    this.perItemToggleTarget.classList.toggle('hide', method !== 'per_line');
  }
}
